import { REVIEWS_STATE } from './constants'
import type { ReviewsState } from './state'

export const getReviews = (state: ReviewsState) => state[REVIEWS_STATE].data
export const getIsFetching = (state: ReviewsState) => state[REVIEWS_STATE].isFetching
export const getFilter = (state: ReviewsState) => state[REVIEWS_STATE].filter
